export class UserActionDuration {
    constructor() {
        this.t0 = performance.now();
    }
    get duration() {
        const t1 = performance.now();  
        return Math.floor(t1 - this.t0);
    }
}